/* ============================================================
   DosZenn, moteur d animation.

   Regle du theme : aucun texte visible n est ecrit ici. Ce
   script ne fait que poser des classes et des valeurs
   numeriques. Tout ce qui se lit vient des reglages de section.

   Il gere quatre choses :
     1. les entrees au defilement    [data-rv]
     2. les compteurs de chiffres    [data-count-to]
     3. le comparateur a curseur     [data-compare]
     4. les points chauds sur image  [data-hotspots]

   Parti pris sur le point 1 : le contenu masque en attente
   d animation est un risque commercial. On ne s appuie donc pas
   sur IntersectionObserver seul, mais sur un balayage cadence
   par requestAnimationFrame, double d un filet de securite au
   chargement complet. Si quoi que ce soit echoue, tout
   s affiche : rien ne peut rester invisible.
   ============================================================ */
(function () {
  'use strict';

  if (window.__dzMotion) return;
  window.__dzMotion = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  /* ---------------- 1. ENTREES AU DEFILEMENT ---------------- */
  var watched = [];
  var ticking = false;

  /* Marge negative : l element entre franchement dans l ecran
     avant de s animer, sans jamais pouvoir rester bloque. */
  function inView(node, slack) {
    var r = node.getBoundingClientRect();
    var vh = viewportHeight();
    return r.bottom > 0 && r.top < vh - slack;
  }

  function sweep(slack) {
    ticking = false;
    var remaining = [];
    for (var i = 0; i < watched.length; i++) {
      var n = watched[i];
      if (inView(n, slack)) n.classList.add('is-in');
      else remaining.push(n);
    }
    watched = remaining;
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () { sweep(48); });
    } else {
      sweep(48);
    }
  }

  function revealAll() {
    watched.forEach(function (n) { n.classList.add('is-in'); });
    watched = [];
  }

  function reveals(root) {
    var nodes = $$('[data-rv]', root || document).filter(function (n) { return !n.__dzSeen; });
    if (!nodes.length) return;

    nodes.forEach(function (n) { n.__dzSeen = 1; });

    if (REDUCED) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }

    watched = watched.concat(nodes);
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  /* Filet de securite : une fois la page entierement chargee, on
     repasse sans marge, puis on laisse le defilement faire le
     reste. Un bloc deja a l ecran ne peut plus rester cache. */
  window.addEventListener('load', function () {
    sweep(0);
    setTimeout(function () { sweep(0); }, 900);
  });

  /* ---------------- 2. COMPTEURS ---------------- */
  function counters(root) {
    $$('[data-count-to]', root || document).forEach(function (n) {
      if (n.__dzCount) return;
      n.__dzCount = 1;

      var raw = String(n.getAttribute('data-count-to')).trim();
      var target = parseFloat(raw.replace(',', '.'));
      if (isNaN(target)) return;

      var decimals = (raw.split(/[.,]/)[1] || '').length;
      var sep = n.getAttribute('data-count-sep') || ',';

      function show(v) {
        var s = v.toFixed(decimals);
        n.textContent = decimals ? s.replace('.', sep) : s;
      }

      if (REDUCED) { show(target); return; }

      function run() {
        var started = null;
        var duration = 1150;
        requestAnimationFrame(function step(now) {
          if (started === null) started = now;
          var p = Math.min(1, (now - started) / duration);
          show(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        });
      }

      if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) { show(target); return; }

      show(0);
      var fired = false;
      var start = function () {
        if (fired) return;
        fired = true;
        run();
      };

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.disconnect();
          start();
        });
      }, { threshold: 0.25 });
      obs.observe(n);

      /* Si l observateur ne se declenche jamais, la valeur finale
         est ecrite quand meme : jamais de zero fige a l ecran. */
      window.addEventListener('load', function () {
        setTimeout(function () {
          if (fired) return;
          var r = n.getBoundingClientRect();
          if (r.bottom > 0 && r.top < viewportHeight()) { obs.disconnect(); start(); }
        }, 1000);
      });
    });
  }

  /* ---------------- 3. COMPARATEUR A CURSEUR ---------------- */
  function compare(root) {
    $$('[data-compare]', root || document).forEach(function (box) {
      if (box.__dzCmp) return;
      box.__dzCmp = 1;

      var range = box.querySelector('[data-compare-range]');
      var stage = box.querySelector('.ba-stage') || box;
      var dragging = false;

      function set(v) {
        box.style.setProperty('--dz-split', v + '%');
      }

      if (range) {
        set(range.value);
        range.addEventListener('input', function () { set(range.value); });
      } else {
        set(50);
      }

      function fromPointer(e) {
        var r = stage.getBoundingClientRect();
        if (!r.width) return;
        var v = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        set(v);
        if (range) range.value = v;
      }

      stage.addEventListener('pointerdown', function (e) {
        dragging = true;
        if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
        fromPointer(e);
      });
      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        fromPointer(e);
      });
      stage.addEventListener('pointerup', function () { dragging = false; });
      stage.addEventListener('pointercancel', function () { dragging = false; });
      window.addEventListener('pointerup', function () { dragging = false; });
    });
  }

  /* ---------------- 4. POINTS CHAUDS SUR IMAGE ---------------- */
  function hotspots(root) {
    $$('[data-hotspots]', root || document).forEach(function (box) {
      if (box.__dzHot) return;
      box.__dzHot = 1;

      var points = $$('[data-hotspot]', box);
      var panels = $$('[data-hotspot-panel]', box);
      if (!points.length) return;

      function open(i) {
        points.forEach(function (p, k) {
          p.classList.toggle('on', k === i);
          p.setAttribute('aria-expanded', k === i ? 'true' : 'false');
        });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      }

      points.forEach(function (p, i) {
        p.addEventListener('click', function () { open(i); });
        p.addEventListener('focus', function () { open(i); });
        p.addEventListener('mouseenter', function () {
          if (window.matchMedia && window.matchMedia('(hover:hover)').matches) open(i);
        });
      });

      open(0);
    });
  }

  /* ---------------- INIT ---------------- */
  function boot(root) {
    reveals(root);
    counters(root);
    compare(root);
    hotspots(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* L editeur de theme recharge les sections a chaud : on rebranche. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  /* Dernier filet : si une erreur inattendue empechait le
     balayage, on affiche tout au bout de cinq secondes. */
  setTimeout(revealAll, 5000);
})();
